<template>
  <div class="section dark narrowLeft paddingBig photoBackground lightPhoto" id="background1">
    <div>
      <div class="banner">
        <div class="header">
          <div class="title">{{ $t("topFeatured.title") }}</div>
          <div v-html="$t('topFeatured.subTitle')" class="subTitle"></div>
        </div>
      </div>
      <ArticlesList :articles="featuredArticles" :typeOfBackground="typeOfBackground" :truncateTitle="true"/>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue'
import getArticles from '../composables/getArticles'
import GENERIC_VARIABLES from "../../config";
import LocalizedLink from "@/components/LocalizedLink.vue"
import ArticlesList from '@/components/ArticlesList.vue'


export default {
  name: 'topFeaturedArticles',
  components: {ArticlesList, LocalizedLink},
  setup() {
    const typeOfBackground = "darkBackground"
    const top = "true"
    const novelties = "false"
    const articlesToShow = 4
    const articleDetailsView = 'ArticleDetails'
    // Mismo alcance de catalogo que PowerTools.vue: si cambia alli, cambia aqui.
    // Los codigos ELK12C0000xx son los antiguos de Golden, se mantienen porque
    // todavia hay articulos colgando de ellos.
    const subcategories = [
      'ELK04A1',
      'ELK04A10',
      'ELK01A055',
      'ELK12C00005',
      'ELK12C00010',
      'ELK12C00015',
      'ELK12C00020',
      'ELK12C00025',
      'ELK12C00035',
      'ELK12C00040',
      'ELK12C00045',
      'ELK12C00055',
      'ELK12C00060',
      'ELK12C00070',
      'ELK12C00073',
      'ELK12C00075',
      'ELK12C00090',
      'ELK12C00095',
      'ELK12C00110',
      'ELK12C00115',
      'ELK12C00120',
      'ELK12C00125',
      'ELK12C00135',
      'ELK12E001',
      'ELK12E010',
      'ELK12C000001',
      'ELK12C0000010',
      'ELK12C0000020',
      'ELK12C0000021',
      'ELK12C0000022',
      'ELK12C0000024',
      'ELK12C0000031',
      'ELK12C0000064',
      'ELK12C0000066',
      'ELK12C0000070',
      'ELK12C0000074',
      'ELK12C0000080',
      'ELK12C0000082',
      'ELK12C0000084',
      'ELK12C0000086',
      'ELK12C0000090',
      'ELK12C0000092',
      'ELK12C0000094',
      'ELK12C0000096',
      'ELK12C000009800',
      'ELK12C000009814'
    ]
    const filters = []

    const generateArticleUrl = (article) => {
      return "/" + article.url[GENERIC_VARIABLES.USER_LANG]['subcategorySlug'] ? article.url[GENERIC_VARIABLES.USER_LANG]['subcategorySlug'] : article.url['es']['subcategorySlug'] + "/" + article.url[GENERIC_VARIABLES.USER_LANG]['articleSlug'] ? article.url[GENERIC_VARIABLES.USER_LANG]['articleSlug'] : article.url['es']['articleSlug'] + "/" + article.id
    }


    /**
     * Fisher-Yates sobre una copia: no se toca el array original.
     */
    const pickRandom = (items, amount) => {
      const shuffled = [...items]

      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const temp = shuffled[i]
        shuffled[i] = shuffled[j]
        shuffled[j] = temp
      }

      return shuffled.slice(0, amount)
    }

    // Se piden todos los destacados y se eligen 4 al azar aqui, en cada carga
    // de pagina: la API no admite orden aleatorio ni offset, con &limit
    // devolveria siempre los mismos.
    const {
      articles,
      error,
      load
    } = getArticles(GENERIC_VARIABLES.PRODUCT_BRAND, subcategories, filters, novelties, top)

    const featuredArticles = ref([])

    load().then(() => {
      featuredArticles.value = pickRandom(articles.value, articlesToShow)
    })

    return {featuredArticles, error, GENERIC_VARIABLES, articleDetailsView, typeOfBackground, generateArticleUrl}
  }
}
</script>